<ap-search-input data-testid="search-input" [formControl]="searchField"></ap-search-input>

@if (optionsToDisplay.length < filteredOptions.length) {
    <ap-notification data-testid="maximum-amount-notification" status="info">
        {{ 'maxOptions.notification' | apContent: { amount: filteredOptions.length.toString(), maximum: maxVisibleOptions.toString() } }}
    </ap-notification>
}

@if (selectionType === 'single') {
    <ap-selector-modal-single
        [selectedOption]="selectedOptions ? selectedOptions[0] : null"
        [options]="optionsToDisplay"
        [groups]="groups"
        [title]="title"
        (selected)="select($event)"
        (openSubModal)="openSubModal($event)"
        tabindex="-1"
        data-testid="selector-single"
    ></ap-selector-modal-single>
} @else {
    <ap-selector-modal-multiple
        [selectedOptions]="selectedOptions"
        [optionsToDisplay]="optionsToDisplay"
        [options]="options"
        [groups]="groups"
        (selected)="select($event)"
        tabindex="-1"
        data-testid="selector-multiple"
    ></ap-selector-modal-multiple>
}
